import { useCallback } from "react";
import {
  apiUrl,
  connectorOauthRedirectBase,
  oidcProviderUrl,
  publicUrl,
} from "../../lib/tenantOrigin";

export function useRenderWithPlaceholders() {
  const externalPublicUrl = publicUrl();
  const externalApiUrl = apiUrl();
  const oauthRedirectBase = connectorOauthRedirectBase();
  const providerUrl = oidcProviderUrl();
  return useCallback(
    (text: string, values?: Record<string, string>) => {
      const staticValues: Record<string, string> = {
        UI_URL: externalPublicUrl,
        API_URL: externalApiUrl,
        OIDC_PROVIDER_URL: providerUrl,
      };
      const rendered = text.replace(/\{([^}]+)\}/g, (match, key) => {
        return values?.[key] ?? staticValues[key] ?? match;
      });
      // Connector manifests spell callback URLs as
      // {API_URL}/connected-apps/oauth/…; rebase them onto the redirect base
      // the OAuth flow actually sends, so copy fields match it exactly.
      return rendered.replaceAll(
        `${externalApiUrl}/connected-apps/oauth/`,
        oauthRedirectBase
      );
    },
    [externalPublicUrl, externalApiUrl, oauthRedirectBase, providerUrl]
  );
}
